<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  created () {
    this.$store.dispatch('income/loadData')
    this.$store.dispatch('expense/loadData')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue